export default __webpack_public_path__ + "static/26-3eb3c5ec26d67baf375617e13b8985dc.jpg";